import axios from "axios";

const API_BASE_URL = "/api";

/**
 * User API Service
 * Handles all HTTP requests related to user operations
 */
class UserService {
  /**
   * Login user
   */
  async login(email, password) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/login`,
        { email, password },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Register user
   */
  async register(userData) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/register`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Request payment
   */
  async requestPayment(userData) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/acc`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Load current user
   */
  async loadUser() {
    try {
      const response = await axios.get(`${API_BASE_URL}/me`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Logout user
   */
  async logout() {
    try {
      const response = await axios.get(`${API_BASE_URL}/logout`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update user profile
   */
  async updateProfile(userData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/me/update`,
        userData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update password
   */
  async updatePassword(passwords) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/password/update`,
        passwords,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Forgot password
   */
  async forgotPassword(email) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/password/forgot`,
        email,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Reset password
   */
  async resetPassword(token, passwords) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/password/reset/${token}`,
        passwords,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all users (Admin)
   */
  async getAllUsers() {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/users`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get user details (Admin)
   */
  async getUserDetails(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/user/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update user (Admin)
   */
  async updateUser(id, userData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/admin/users/${id}`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete user (Admin)
   */
  async deleteUser(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/admin/users/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data?.message || "An error occurred",
        status: error.response.status,
        data: error.response.data,
      };
    } else if (error.request) {
      return {
        message: "Network error. Please check your connection.",
        status: 0,
      };
    } else {
      return {
        message: error.message || "An unexpected error occurred",
        status: 0,
      };
    }
  }
}

const userService = new UserService();
export default userService;

